export default {
  H1: [48, 56],
  H2: [40, 48],
  H3: [32, 40],
  H4: [24, 32],
  H5: [20, 28],
  body1: [18, 26],
  body2: [16, 24],
  body3: [14, 20],
  caption: [12, 16],
  tinny: [10, 14],
};
